import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { ArrivalScreen } from "@/features/arrival/components/arrival-screen";
import { formCodeOf, isFormSlug } from "@/features/arrival/forms";

export const Route = createFileRoute("/_app/arrivals/$form/$id")({
  params: {
    parse: ({ form, id }) => {
      if (!isFormSlug(form) || !/^\d+$/.test(id)) throw notFound();
      return { form, id };
    },
    stringify: (p) => p,
  },
  beforeLoad: ({ params }) => {
    const auth = useAuth.getState();
    if (
      !auth.can("document.view") ||
      !auth.canViewForm(formCodeOf(params.form))
    )
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  // Every arrival is one document on one page; a Cob Arrival's lots go on to the Dryer (2026-09-29).
  return <ArrivalScreen id={Number(id)} />;
}
